import instance from '../../api'

const BASE_ENDPOINT = '/api/public/stores'

export const getStoreFromParam = (urlParam) => instance.get(`${BASE_ENDPOINT}/${urlParam}`)
export const updateStoreFromParam = (urlParam, fields) => instance.put(`${BASE_ENDPOINT}/${urlParam}`, fields)
